import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardTitle,
  IonFab,
  IonFabButton,
  IonIcon,
} from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { alertSharp } from 'ionicons/icons';
import { HelperFunctionsService } from '../helpers/helper-functions.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'lib-app-puzzle-compatibillity-warning',
  templateUrl: './puzzle-compatibillity-warning.component.html',
  styleUrls: ['./puzzle-compatibillity-warning.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonCardTitle,
    IonFab,
    IonFabButton,
    IonIcon,
    TranslateModule,
  ],
})
export class PuzzleCompatibillityWarningComponent {
  incompatibility: string;

  constructor(private helperFunctionSerice: HelperFunctionsService) {
    addIcons({ alertSharp });
    if (this.helperFunctionSerice.isAndroid() && this.helperFunctionSerice.isFirefox()) {
      this.incompatibility = 'android_firefox';
    } else {
      this.incompatibility = 'default';
    }
  }
}
